<template>
    <!-- <div class="grid grid-cols-3 text-center text-16 text-a-gray-666666 font-text border-b cursor-pointer select-none mt-6" v-show="isShowCode">
        <div class="pb-3.5"
            :style="getThemeActive('QR_CODE')"
            @click="changeTab('QR_CODE')">
            {{lbl.serial.qr_code}}
        </div>
        <div class="pb-3.5"
            :style="getThemeActive('CODE_128')"
            @click="changeTab('CODE_128')">
            {{lbl.serial.barcode}}
        </div>
        <div class="pb-3.5 "
            :style="getThemeActive('CODE')"
            @click="changeTab('CODE')">
            {{lbl.serial.code}}
        </div>
    </div> -->
    <div class="pt-4 pb-5 px-20">
        <PrivilegeMessage :serialModel="serialModel" :lbl="lbl"></PrivilegeMessage>
    </div>
    <div class="flex justify-center items-center wrap-code ">
        <div class="relative" v-show="serialType == 'QR_CODE'">
            <VueQrcode  :value="serial" :options="qrOption"></VueQrcode>
            <div class="absolute w-full top-28 left-0">
                <div class="flex justify-center">
                    <img class="h-10" src="../../../../assets/icon/ic-pwp-mepoint-qr.png"/>
                </div>
            </div>
        </div>
        <div v-show="serialType == 'CODE_128'">
            <VueBarcode :value="serial" :options="barcodeOption"></VueBarcode>
        </div>
        <div v-show="serialType == 'CODE'">
            <div class="text-xl font-bold">{{serial}}</div>
            <!-- <button
                v-clipboard:copy="serial"
                v-clipboard:success="onCopy($event)">Copy</button> -->
        </div>
    </div>
</template>
<script>
// import LocaleMixin from "@/mixin/LocaleMixin.js";
//lib
import VueBarcode from '@chenfengyuan/vue-barcode';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import PrivilegeMessage from "./PrivilegeMessage.vue";

export default {
    name: "Serial",
    // mixins: [LocaleMixin],
    components: {
        VueBarcode,
        VueQrcode,
        PrivilegeMessage
    },
    props: {
        serialModel: Object,
        lbl: Object,
        blobConfig: Object
    },
    data: function() {
        return {
            serialType: 'QR_CODE', // CODE, QR_CODE, CODE_128
            classActiveTab: '',
            ActiveTab: {
                color: "",
                borderBottom: "2px solid",
                borderColor: ""
            },
            isExpired: false,
            isLoaded: false,
            isShowCode: false,
            isTabLock: false,
            privilegeMsg: '',
            serial: '',

            qrOption: {
                width: 250,
                margin: 0,
            },
            barcodeOption: {
                height: 100,
                displayValue: false,
                lineColor: '#000000',
                width: 1,
            },
        };
    },
    created: function() {
        this.initial();
        this.setupTheme();
    },
    methods: {
        initial: function () {
            if (!this.serialModel.serial) {
                return;
            }

            this.isExpired = false;
            this.serial = this.serialModel.serial;
            switch (this.serialModel.serialType) {
                case 'CODE_128':
                    this.serialType = 'CODE_128';
                    break;
                case 'CODE':
                    this.serialType = 'CODE';
                    break;
                default:
                    this.serialType = 'QR_CODE';
                    break;
            }

            if (this.serialModel.serialType && this.serialModel.serialType.toLowerCase() == 'none' && this.serialModel.privilegeMessage) {
                this.isShowCode = false;
            }
        },

        changeTab: function (type) {
            if (this.isTabLock) return;

            this.serialType = type;
        },

        setSerialExpire: function() {
            this.serial = "XXXXXX";
            this.isExpired = true;
            this.isTabLock = true;
            this.serialType = "CODE";
        },
        onCopy: function() {
            // on copy serial event
        },
        getThemeActive: function(strTab) {
            if (this.serialType == strTab) {
                return this.ActiveTab;
            }
        },
        setupTheme: function() {
            this.ActiveTab.color = this.blobConfig.appConfig.blobConfig.text_color;
            this.ActiveTab.borderColor = this.blobConfig.appConfig.blobConfig.btn_color;
        },
    },
}
</script>
<style lang="scss" scoped>
@import '../../../../style/base.scss';
.font-text {
    font-family: $ff-text;
}
.font-Medium {
    font-family: $ff-Medium;
}
.font-semiBold {
    font-family: $ff-semi;
}
.wrap-code {
    height: fit-content;
}
</style>
